// @ts-check
import { api } from "../client.js";

/**
 * Endpoints de autenticação.
 *
 * Cada recurso da API tem um arquivo assim: as URLs ficam todas num lugar,
 * e as telas chamam funções com nome, não strings soltas.
 */
export const authApi = {
  /** @param {{ email: string, password: string }} credenciais */
  login: (credenciais) => api.post("/auth/login", credenciais),

  logout: () => api.post("/auth/logout"),

  /** Sessão atual; lança 401 se não houver. */
  me: () => api.get("/auth/me"),

  /** @param {{ currentPassword: string, newPassword: string }} dados */
  changePassword: (dados) => api.post("/auth/change-password", dados),

  sessions: () => api.get("/auth/sessions"),
};
